import type * as React from 'react';
import * as style from './style.css';

interface ITooltipTextProps {
  text: string;
}

export const TooltipText = ({ text }: ITooltipTextProps): React.JSX.Element => {
  return <span className={style['text']}>{text}</span>;
};
